import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Configurator from "@/components/Configurator";

function App() {
  return (
    <div className="App grain min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Configurator />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
